import { Helmet as HelmetAsync } from 'react-helmet-async';
import { config } from '../../../config';

export const Helmet = ({ title, href = undefined, description = '', children }) => {
  const siteUrl = config['global.siteBaseUrl'];
  // If passed no href, doesn't output canonical
  // If passed empty string, outputs base url
  // else append the passed href to base url
  const canonicalUrl = href === undefined ? null : `${siteUrl}${href}`;

  return (
    <HelmetAsync>
      <title>{title}</title>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {description && <meta name="description" content={description} />}
      {children}
    </HelmetAsync>
  );
};
